import { type TileIndex } from "@/types/tile";
import { FrameName } from "../config";
import TileEntity from "../TileEntity";

type CattleRangeFrameName =
	| FrameName.CATTLE_RANGE
	| FrameName.CATTLE_RANGE_SPECIAL;

class CattleRangeBuildingTileEntity extends TileEntity {
	public static readonly frameName: CattleRangeFrameName =
		FrameName.CATTLE_RANGE;

	public get suppliesTileIndexes(): Set<TileIndex> {
		return new Set<TileIndex>(
			// zasobuje len 1 farmu
			Array.from(super.suppliesTileIndexes).slice(0, 1),
		);
	}
}

export default CattleRangeBuildingTileEntity;
